class BlogSupportArticlesSearch extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      machineSearchInput: this.querySelector('#blog-support-articles-search'),
    };
    this.loadEventListeners = undefined;

    this.initialLoad = this.initialLoad.bind(this);
    this.setupAlgoliaBlogSupportArticles = this.setupAlgoliaBlogSupportArticles.bind(this);
    this.algoliaInitConfig = this.algoliaInitConfig.bind(this);
    this.algoliaAutocompleteInstance = this.algoliaAutocompleteInstance.bind(this);

    this.elements.machineSearchInput.addEventListener('focus', this.initialLoad);
  }

  initialLoad() {
    const algoliaExists =
      typeof algoliaShopify !== 'undefined' &&
      typeof window.algoliaShopify !== 'undefined' &&
      algoliaShopify.externals !== 'undefined' &&
      algoliaShopify.externals.autocomplete !== 'undefined'
        ? true
        : false;
    if (algoliaExists) this.setupAlgoliaBlogSupportArticles();
    if (!algoliaExists) {
      loadAlgolia();
      this.loadEventListeners = setInterval(this.setupAlgoliaBlogSupportArticles, 100);
    }
  }

  setupAlgoliaBlogSupportArticles() {
    if (
      typeof algoliaShopify !== 'undefined' &&
      typeof window.algoliaShopify !== 'undefined' &&
      typeof algoliaShopify.externals !== 'undefined' &&
      algoliaShopify.externals.autocomplete !== 'undefined'
    ) {
      let aaConfig = this.algoliaInitConfig();
      let aaInstance = this.algoliaAutocompleteInstance(aaConfig.autocomplete, aaConfig.autocompleteSection, aaConfig.config);
      this.elements.machineSearchInput.removeEventListener('focus', this.initialLoad);
      if (this.loadEventListeners) clearInterval(this.loadEventListeners);
    }
    return;
  }

  algoliaInitConfig() {
    const autocomplete = algoliaShopify.externals.autocomplete;
    const searchClient = algoliaShopify.externals.algoliasearch(algoliaShopify.config.app_id, algoliaShopify.config.search_api_key);
    const index = searchClient.initIndex(algoliaShopify.config.index_prefix + 'articles');
    const config = {
      hitsPerPage: 10,
      index: index,
      templates: {
        empty: algoliaShopify.compileTemplate('autocomplete_blog_articles_search_empty'),
        hit: algoliaShopify.compileTemplate('autocomplete_blog_articles_search'),
      },
    };

    algoliaShopify.appendStyle(
      algoliaShopify.render(algoliaShopify.compileTemplate('autocomplete.css'), {
        colors: algoliaShopify.config.colors,
      })
    );

    function createMultiQuerySource() {
      let queue = [];
      let lastResults = [];
      let lastSearch = Promise.resolve();

      function requestSearch(index) {
        return Promise.resolve()
          .then(() => {
            if (queue.length) {
              lastSearch = searchClient.search(queue);
              queue = [];
            }
            return lastSearch;
          })
          .then((result) => {
            if (result) {
              lastResults = result.results;
            }
            return lastResults[index];
          });
      }

      return function multiQuerySource(singleIndex, params, extendHits = null) {
        return function search(query, cb) {
          const index = queue.push({ indexName: singleIndex.indexName, query, params }) - 1;
          requestSearch(index)
            .then((res) => {
              var extendedHits = [];
              if (extendHits) {
                extendedHits = extendHits(res);
              } else {
                extendedHits = res.hits;
              }
              return cb(extendedHits, res);
            })
            .catch((err) => cb([], err));
        };
      };
    }

    const multiQuerySource = createMultiQuerySource();

    function autocompleteSection(config) {
      var templates = {
        empty: function displayEmptyResultSet(props) {
          return algoliaShopify.render(config.templates.empty, algoliaShopify.assign({}, props, { translations: algoliaShopify.translations }));
        },
        suggestion: function displaySuggestion(hit) {
          return algoliaShopify.render(
            config.templates.hit,
            algoliaShopify.assign(hit, {
              translations: algoliaShopify.translations,
            })
          );
        },
      };

      var searchOpts = {
        clickAnalytics: true,
        hitsPerPage: 10,
        highlightPreTag: '<span class="aa-highlight">',
        highlightPostTag: '</span>',
        facetFilters: [['blog.title:Support Articles', 'blog.title:Customer Service']],
      };

      function extendHits(answer) {
        return answer.hits.map(function (hit, i) {
          return algoliaShopify.assign({}, hit, {
            _position: i + 1,
            _queryID: answer.queryID,
            _index: algoliaShopify.config.index_prefix + 'articles',
          });
        });
      }

      return {
        name: 'articles',
        source: multiQuerySource(index, searchOpts, extendHits),
        displayKey: 'title',
        templates: templates,
      };
    }

    return {
      autocomplete: autocomplete,
      autocompleteSection: autocompleteSection,
      config: config,
    };
  }

  algoliaAutocompleteInstance(autocomplete, autocompleteSection, config) {
    const createInstance = autocomplete(
      '#blog-support-articles-search',
      {
        debug: false,
        hint: false,
        appendTo: 'body',
        templates: {
          dropdownMenu: algoliaShopify.render(algoliaShopify.compileTemplate('autocomplete'), {
            storeName: algoliaShopify.storeName,
            with: {
              articles: algoliaShopify.config.index_articles,
              blogSupportArticlesSearch: true,
            },
          }),
          empty: '<div></div>',
        },
        cssClasses: {
          root: 'algolia-autocomplete blog-support-articles-search',
        },
      },
      [algoliaShopify.config.index_articles && autocompleteSection(config)].filter(function (x) {
        return Boolean(x);
      })
    );

    // Hack to handle buggy onclick event on iOS
    createInstance.each(function (i) {
      var data = createInstance.eq(i).data('aaAutocomplete');
      var suggestionClass = '.' + data.dropdown.cssClasses.prefix + '-' + data.dropdown.cssClasses.suggestion;
      var onSuggestionClick = data.dropdown._onSuggestionClick.bind(data.dropdown);

      var touchmoved;
      data.dropdown.$menu
        .on('touchend', suggestionClass, function (e) {
          if (touchmoved === false) {
            e.preventDefault();
            e.stopPropagation();
            onSuggestionClick.apply(this, arguments);
          }
        })
        .on('touchmove', function () {
          touchmoved = true;
        })
        .on('touchstart', function () {
          touchmoved = false;
        });
    });

    // Event listeners
    createInstance.on('autocomplete:selected', function (obj, datum, name) {
      if (algoliaShopify.config.analytics_enabled) {
        var clickData = {
          index: datum._index,
          eventName: 'click',
          queryID: datum._queryID,
          objectIDs: [datum.objectID],
          positions: [datum._position],
        };

        // Send the click event
        aa.clickedObjectIDsAfterSearch(clickData);
      }
      this.dataset.value = datum.handle;
    });

    createInstance.on('autocomplete:redrawn', function () {
      var that = this;
      var i;
      createInstance.each(function (j, item) {
        if (item === that) {
          i = j;
          return false;
        }
        return true;
      });
    });

    return createInstance;
  }
}

customElements.define('blog-support-articles-search', BlogSupportArticlesSearch);
